import React from 'react';
/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/img-redundant-alt */
const Articles = () => {
  const articles = [
    {
      id: 1,
      icon: '📱',
      date: 'February 10, 2026',
      title: 'Building Scalable React Native Apps',
      description: 'Best practices for architecting mobile applications that grow with your business. Learn about state management, navigation patterns, and performance optimization.'
    },
    {
      id: 2,
      icon: '☁️',
      date: 'February 5, 2026',
      title: 'AWS Cost Optimization Strategies',
      description: 'Practical tips to reduce cloud costs without sacrificing performance. From right-sizing instances to leveraging spot instances and reserved capacity.'
    },
    {
      id: 3,
      icon: '🤖',
      date: 'January 28, 2026',
      title: 'AI Integration in Web Applications',
      description: 'How to add intelligent features to your web apps using modern AI APIs. Real-world examples of chatbots, recommendations, and content generation.'
    },
    {
      id: 4,
      icon: '⚡',
      date: 'January 22, 2026',
      title: 'Next.js 15: What\'s New and Why It Matters',
      description: 'Exploring the latest features in Next.js 15 including improved performance, new rendering strategies, and enhanced developer experience.'
    },
    {
      id: 5,
      icon: '🔒',
      date: 'January 15, 2026',
      title: 'Security Best Practices for Modern Web Apps',
      description: 'Essential security measures every developer should implement. From authentication to data encryption and protection against common vulnerabilities.'
    },
    {
      id: 6,
      icon: '🎯',
      date: 'January 8, 2026',
      title: 'Microservices vs Monolith: Making the Right Choice',
      description: 'A practical guide to choosing the right architecture for your project. When to use microservices and when a monolithic approach makes more sense.'
    }
  ];

  return (
    <div className="page-content active">
      <section className="hero" style={{ minHeight: '400px' }}>
        <div className="hero-container" style={{ gridTemplateColumns: '1fr' }}>
          <div className="hero-content" style={{ textAlign: 'center' }}>
            <h1>Tech <span className="highlight">Insights</span></h1>
            <p>Thoughts, tutorials, and industry perspectives from our team</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="articles-grid">
          {articles.map((article) => (
            <div key={article.id} className="article-card">
              <div className="article-image">{article.icon}</div>
              <div className="article-content">
                <div className="article-date">{article.date}</div>
                <h3>{article.title}</h3>
                <p>{article.description}</p>
                {/* <a href="/" className="read-more">Read More →</a> */}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Articles;
